import { cn } from '@/lib/utils';

interface StatCardProps {
  value: string;
  label: string;
  color?: 'purple' | 'amber' | 'blue' | 'green' | 'orange' | 'cyan' | 'pink';
  className?: string;
}

const colorMap = {
  purple: 'text-white',
  amber: 'text-white',
  blue: 'text-slate-100',
  green: 'text-emerald-400',
  orange: 'text-white',
  cyan: 'text-slate-100',
  pink: 'text-white',
};

export function StatCard({ value, label, color = 'purple', className }: StatCardProps) {
  return (
    <div
      className={cn('bg-white/[0.03] rounded-xl p-6 text-center border border-white/10', className)}
    >
      <p className={cn('text-4xl font-bold tracking-tight', colorMap[color])}>{value}</p>
      <p className="text-sm text-slate-300 mt-1">{label}</p>
    </div>
  );
}

export default StatCard;
